module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.scss
// module id = ./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.scss
// module chunks = 0